import React, { Fragment, useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { Breadcrumbs, H3 } from "../../../../AbstractElements";
import { Card, CardHeader, Form, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { AddItem, ProOption, SEO, AdditionImage } from "../../../../Constant";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addStoreItem } from "../../../../CommonUrl";
import Transparentspinner from "../../../Common/Loader/Transparentspinner";
import HandleApiError from "../../../Common/ErrorImport/ErrorImport";
import DefaultForm from "./Default";
import { postClientUrlWithToken } from "../../../../Utils/restUtils";
import ItemForm from "./Item";
import ProOptionForm from "./ProOption";
import SEOForm from "./SEO";
import { toast } from 'react-toastify';

const productSchema = yup.object().shape({
    point: yup
        .string()
        .required('Point is required')
        .min(0, 'Point cannot be negative'),

    minOrder: yup
        .string()
        .required('Minimum order is required')
        .test("min-required-if-max", "Minimum order is required", function (value) {
            const { maxOrder } = this.parent;
            return !(maxOrder && (value === null || value === undefined || value === ""));
        })
        .test(
            "min-less-than-max",
            "Minimum must be less than maximum",
            function (value) {
                const { maxOrder } = this.parent;
                if (value && maxOrder) {
                    return Number(value) < Number(maxOrder);
                }
                return true;
            }
        ),

    maxOrder: yup
        .string()
        .required('Maximum order is required')
        .test("max-required-if-min", "Maximum order is required", function (value) {
            const { minOrder } = this.parent;
            return !(minOrder && (value === null || value === undefined || value === ""));
        })
        .test(
            "max-greater-than-min",
            "Maximum must be greater than minimum",
            function (value) {
                const { minOrder } = this.parent;
                if (value && minOrder) {
                    return Number(value) > Number(minOrder);
                }
                return true;
            }
        ),

    category: yup
        .mixed()
        .required('Category is required'),

    quantity: yup
        .string()
        .required('Quantity is required')
        .min(0, 'Quantity cannot be negative'),

    purchase_price: yup
        .string()
        .required('Purchase price is required')
        .min(0, 'Purchase price cannot be negative'),

    sales_price: yup
        .string()
        .required('Sales price is required')
        .min(0, 'Sales price cannot be negative'),

    sku: yup
        .string()
        .required('SKU is required')
    ,
   mainImage: yup
  .mixed()
  .required("Image is required")
  .test("fileRequired", "Image is required", (value) => {
    return value && value.length > 0;
  }),

    itemName: yup
        .string()
        .required('Item name is required'),


});


const ItemAddTab = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [IconWithTab, setIconWithTab] = useState('1');
    const [uploadedImages, setUploadedImages] = useState([]);
    const authState = useSelector((state) => state.auth);

    useEffect(() => {
        const inputElement = document.querySelectorAll('input[type="number"]');
        const preventScrollEvent = (event) => {
            event.preventDefault();
        };
        inputElement.forEach((inputElement) => {
            inputElement.addEventListener('wheel', preventScrollEvent);

        });
    }, []);

    const { register, handleSubmit, setValue, control, trigger, formState: { errors }, getValues } = useForm({
        resolver: yupResolver(productSchema),
        mode: 'onChange',
        defaultValues: {
            rows: [
                {
                    attribute: null,
                    attributeValue: null,
                    stock: '',
                    price: '',
                    images: ''
                }
            ]
        }
    });

    const { fields, append, remove } = useFieldArray({
        control,
        name: 'rows'
    });

    const onSubmit = async (data) => {
        console.log(data)
        setLoading(true)
        const formData = new FormData();
        const filteredRows = data.rows.filter((item) => item.attribute?.value);
        const apiData = filteredRows.map((item, index) => {
            if (item.images) {
                formData.append(`attribute_images[${index}]`, item.images);
            }
            return {
                attribute_id: item.attribute?.value ?? null,
                option_id: item.attributeValue?.value ?? null,
                stock: Number(item.stock),
                price: Number(item.price),
                image: `attribute_images[${index}]`
            }
        });
        formData.append("name", data.itemName);
        formData.append("sku", data.sku);
        formData.append("sale_price", data.sales_price);
        formData.append("purchase_price", data.purchase_price);
        formData.append("quantity", data.quantity);
        formData.append("category_id", data.category?.value);
        formData.append("tax_group_id", data.tax?.value||'');
        formData.append("weight", data.weight);
        formData.append("min_order", data.minOrder);
        formData.append("max_order", data.maxOrder);
        formData.append("featured", data?.isFeatured === 1 ? 1 : 0);
        formData.append("website_show", data?.isWeb === 1 ? 1 : 0);
        formData.append("delivery_charge", data?.isShip === 1 ? 1 : 0);
        formData.append("points", data?.point);
        formData.append("seo_title", data?.metaTitle||'');
        formData.append("seo_description", data?.metaDescription||'');
        formData.append("description", data?.description||'');
        if (apiData.length > 0) {
            formData.append('attribute', JSON.stringify(apiData));
        }
        formData.append("image", data.mainImage[0]);
        uploadedImages.forEach((image) => {
            formData.append("additional_images[]", image);
        });

        const postResponce = await postClientUrlWithToken(
            authState.apiUrl, addStoreItem, formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        if (postResponce.status === 200) {
            if (postResponce?.data?.status === true) {
                toast.success(postResponce?.data?.message);
                navigate(`${process.env.PUBLIC_URL}/Products/item`);
                setLoading(false)
            } else {
                if (Array.isArray(postResponce?.data.message)) {
                    postResponce.data.map((e) => { e.message })
                } else {
                    toast.error(postResponce?.data?.message);
                }
                setLoading(false)
            }
        } else if (postResponce.status >= 400 && postResponce.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (postResponce.status >= 500 && postResponce.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false)

    }

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                <Breadcrumbs mainTitle={AddItem} parent="Product" title={AddItem} />
                <Card className="tab-company-edit">
                    <Nav className="nav-primary" tabs>
                        <NavItem >
                            <NavLink className={IconWithTab === '1' ? 'active' : ''} onClick={() => setIconWithTab('1')}><span className="fs-6 fw-bold cursor ">{AddItem}</span></NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={IconWithTab === '2' ? 'active' : ''} onClick={() => setIconWithTab('2')}><span className="fs-6 fw-bold cursor">{ProOption}</span></NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={IconWithTab === '3' ? 'active' : ''} onClick={() => setIconWithTab('3')}><span className="fs-6 fw-bold cursor">{SEO}</span></NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={IconWithTab === '4' ? 'active' : ''} onClick={() => setIconWithTab('4')}><span className="fs-6 fw-bold cursor">{AdditionImage}</span></NavLink>
                        </NavItem>
                    </Nav>

                    <TabContent activeTab={IconWithTab}>
                        <TabPane className="fade show" tabId="1">
                            <CardHeader className="pb-0">
                                <H3>{AddItem}</H3>
                            </CardHeader>
                            <ItemForm register={register} trigger={trigger} control={control} errors={errors} setNextTab={setIconWithTab} getValues={getValues} />
                        </TabPane>
                        <TabPane tabId="2">
                            <CardHeader className="card-text-color pb-0">
                                <H3>{ProOption}</H3>
                            </CardHeader>
                            <ProOptionForm
                                register={register} control={control} errors={errors} setNextTab={setIconWithTab}
                                setValue={setValue} fields={fields} append={append} remove={remove}
                            />
                        </TabPane>
                        <TabPane tabId="3">
                            <CardHeader className="card-text-color pb-0">
                                <H3>{SEO}</H3>
                            </CardHeader>
                            <SEOForm register={register} control={control} setNextTab={setIconWithTab} />
                        </TabPane>
                        <TabPane tabId="4">
                            <CardHeader className="card-text-color pb-0">
                                <H3>{AdditionImage}</H3>
                            </CardHeader>
                            <DefaultForm images={uploadedImages} setImages={setUploadedImages} />
                        </TabPane>
                    </TabContent>

                </Card>
            </Form>
        </Fragment>
    );
};

export default ItemAddTab;
